var _moduleViewerMap;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// Auto-generated by「tnpm run generate」after you added a new module!
import { EComponent } from "./enum";
import { lazy } from "react";
export var moduleViewerMap = (_moduleViewerMap = {}, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_moduleViewerMap, EComponent.Accordion, /*#__PURE__*/lazy(function () {
  return import("./accordion/viewer");
})), EComponent.Attachment, /*#__PURE__*/lazy(function () {
  return import("./attachment/viewer");
})), EComponent.Button, /*#__PURE__*/lazy(function () {
  return import("./button/viewer");
})), EComponent.Carousel, /*#__PURE__*/lazy(function () {
  return import("./carousel/viewer");
})), EComponent.Default, /*#__PURE__*/lazy(function () {
  return import("./default/viewer");
})), EComponent.Divider, /*#__PURE__*/lazy(function () {
  return import("./divider/viewer");
})), EComponent.Faq, /*#__PURE__*/lazy(function () {
  return import("./faq/viewer");
})), EComponent.FullScreenImage, /*#__PURE__*/lazy(function () {
  return import("./full-screen-image/viewer");
})), EComponent.Images, /*#__PURE__*/lazy(function () {
  return import("./images/viewer");
})), EComponent.KnowledgeMatch, /*#__PURE__*/lazy(function () {
  return import("./knowledge-match/viewer");
})), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_moduleViewerMap, EComponent.KnowledgeSingleChoice, /*#__PURE__*/lazy(function () {
  return import("./knowledge-single-choice/viewer");
})), EComponent.LearningPathway, /*#__PURE__*/lazy(function () {
  return import("./learning-pathway/viewer");
})), EComponent.List, /*#__PURE__*/lazy(function () {
  return import("./list/viewer");
})), EComponent.ListImageAndTextDialog, /*#__PURE__*/lazy(function () {
  return import("./list-image-and-text-dialog/viewer");
})), EComponent.MultiColumnImageAndLink, /*#__PURE__*/lazy(function () {
  return import("./multi-column-image-and-link/viewer");
})), EComponent.MultiColumnImageAndText, /*#__PURE__*/lazy(function () {
  return import("./multi-column-image-and-text/viewer");
})), EComponent.Notice, /*#__PURE__*/lazy(function () {
  return import("./notice/viewer");
})), EComponent.Quote, /*#__PURE__*/lazy(function () {
  return import("./quote/viewer");
})), EComponent.SpecialProgram, /*#__PURE__*/lazy(function () {
  return import("./special-program/viewer");
})), EComponent.Tabs, /*#__PURE__*/lazy(function () {
  return import("./tabs/viewer");
})), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_moduleViewerMap, EComponent.Text, /*#__PURE__*/lazy(function () {
  return import("./text/viewer");
})), EComponent.TextBesideImage, /*#__PURE__*/lazy(function () {
  return import("./text-beside-image/viewer");
})), EComponent.TextButton, /*#__PURE__*/lazy(function () {
  return import("./text-button/viewer");
})), EComponent.TextOnImage, /*#__PURE__*/lazy(function () {
  return import("./text-on-image/viewer");
})), EComponent.Video, /*#__PURE__*/lazy(function () {
  return import("./video/viewer");
})), EComponent.YoutubePlayer, /*#__PURE__*/lazy(function () {
  return import("./youtube-player/viewer");
})));